import dayJs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/es'
import 'dayjs/locale/pt-br'
import 'dayjs/locale/en'

dayJs.extend(relativeTime);
dayJs.extend(localizedFormat)
dayJs.extend(updateLocale)
dayJs.extend(utc)
dayJs.extend(timezone)
dayJs.updateLocale('en', {
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: 'Just now',
        m: "1m",
        mm: "%dm",
        h: "1h",
        hh: "%dh",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    }
})
dayJs.updateLocale('pt-br', {
    relativeTime:{
        future:"em %s",
        past:"há %s",
        s: "Agora mesmo",
        m:"1m",
        mm:"%dm",
        h:"1h",
        hh:"%dh",
        d:"um dia",
        dd:"%d dias",
        M:"um mês",
        MM:"%d meses",
        y:"um ano",
        yy:"%d anos"
    }
})
dayJs.updateLocale('es', {
    relativeTime: {
        future: "en %s",
        past: "hace %s",
        s: 'En este momento',
        m: "1m",
        mm: "%dm",
        h: "1h",
        hh: "%dh",
        d: "un día",
        dd: "%d días",
        M: "un mes",
        MM: "%d meses",
        y: "un año",
        yy: "%d años"
    }
})


export function getUploadDate(sentDate, locale) {
    dayJs.locale('en');
    if (locale == 'pt') {
        dayJs.locale('pt-br');
    } else if (locale == 'es') {
        dayJs.locale('es');
    }

    if (sentDate == '' || sentDate == undefined) {
        return sentDate;
    }
    const ts = dayJs.tz(sentDate, "EST");
    let newDate = '';

    if (ts != "Invalid Date") {
        const today = dayJs();
        let todayMessages = today.diff(ts, 'day');
        if (todayMessages == 0) {
            let formattedDate = dayJs(ts).fromNow(true);
            newDate = formattedDate;
        } else if (todayMessages < 7) {
            // show the day of the week and time
            let formattedDate = dayJs(ts).format('ddd');
            newDate = formattedDate;
        } else {
            // show a timestamp for that day
            let formattedDate;
            if (today.format('YYYY') == ts.format('YYYY')) {
                if (locale == 'en') {
                    formattedDate = dayJs(ts).format('MMM D');
                } else {
                    formattedDate = dayJs(ts).format('ll');
                }
            } else {
                formattedDate = dayJs(ts).format('L');
            }
            newDate = formattedDate;
        }
    }
    return newDate;
}

export function getUploadTime(sentDate) {
    dayJs.locale('en');
    if (this.$root.$i18n.locale == 'pt') {
        dayJs.locale('pt-br');
    } else if (this.$root.$i18n.locale == 'es') {
        dayJs.locale('es');
    }
    // Check if the sentDate is in microseconds and convert to seconds if necessary
    if (sentDate.toString().length === 13) {
        sentDate = Math.floor(sentDate / 1000);
    }
    const ts = dayJs.unix(sentDate);
    const today = dayJs();
    let todayMessages = today.diff(ts, 'day');
    let newDate = '';
    if (ts != "Invalid Date") {
        if (todayMessages == 0) {
            let formattedDate = dayJs(ts).fromNow(true);
            newDate = formattedDate;
        } else if (todayMessages < 7) {
            // show the day of the week and time
            let formattedDate = dayJs(ts).format('dddd, LT');
            newDate = formattedDate;
        } else {
            // show a timestamp for that day
            let formattedDate = dayJs(ts).format('L LT');
            newDate = formattedDate;
        }
    }
    return newDate;
}

export function getUploadTimeNow(sentDate, suffix = true) {
    dayJs.locale('en');
    if (this.$root.$i18n.locale == 'pt') {
        dayJs.locale('pt-br');
    } else if (this.$root.$i18n.locale == 'es') {
        dayJs.locale('es');
    }
    if (sentDate == '' || sentDate == undefined) {
        return sentDate;
    }
    // Check if the sentDate is in microseconds and convert to seconds if necessary
    if (sentDate.toString().length === 13) {
        sentDate = Math.floor(sentDate / 1000);
    }
    let ts = dayJs.unix(sentDate);
    let newDate = '';
    if (ts != "Invalid Date") {
        let formattedDate = dayJs(ts).fromNow(suffix);
        newDate = formattedDate;
    }
    return newDate;
}

export function showTime(date_time, messageIndex, messages) {
    if (!messages || !Array.isArray(messages) || messages.length === 0 || !date_time) {
        return false; // Do not display time if inputs are invalid
    }

    let display = true;

    if (messageIndex - 1 >= 0) {
        const prevIndex = messageIndex - 1;

        // Normalize timestamps
        date_time = normalizeTimestamp(date_time);
        const prevDateTime = normalizeTimestamp(messages[prevIndex]?.date_time);

        const messageDate = dayJs.unix(date_time);
        const prevMessageDate = dayJs.unix(prevDateTime);

        // Check for invalid dates
        if (!messageDate.isValid() || !prevMessageDate.isValid()) {
            return false;
        }

        const today = dayJs();
        const daysSinceMessage = today.diff(messageDate, 'day');
        const isSameDay = messageDate.diff(prevMessageDate, 'day') === 0;
        const isSameHour = messageDate.diff(prevMessageDate, 'hour') === 0;

        // Determine whether to display the timestamp
        if (daysSinceMessage === 0) {
            if (isSameDay && isSameHour) {
                display = false;
            }
        } else if (isSameDay) {
            display = false;
        }
    }

    return display;
}

// Utility function to normalize timestamps
function normalizeTimestamp(timestamp) {
    return timestamp.toString().length === 13 ? Math.floor(timestamp / 1000) : timestamp;
}